import { StatusPillVariant } from './status-pill.component';

/** Mapea el texto de estado Verifactu (tal como lo devuelve la API) a la variante de color del pill. */
export function verifactuBadgeVariant(value: string): StatusPillVariant {
  switch ((value || '').trim()) {
    case 'Aceptada': return 'success';
    case 'Rechazada':
    case 'Fallo al enviar': return 'danger';
    case 'No autorizada': return 'neutral';
    case 'En proceso': return 'info';
    case 'Pendiente envío':
    case 'Pendiente de subsanar': return 'warning';
    default: return 'neutral';
  }
}

export const VERIFACTU_NOT_SENT_TOOLTIP =
  'Esta factura no se ha enviado a Verifactu porque todavía no es obligatorio. ' +
  'Verifactu será obligatorio a partir del 1 de enero de 2027 para sociedades ' +
  'y del 1 de julio de 2027 para autónomos. No tienes que hacer nada.';

/** Texto de ayuda del pill de Verifactu, o null si el estado no necesita explicación. */
export function verifactuStatusTooltip(value: string): string | null {
  return (value || '').trim() === 'No autorizada' ? VERIFACTU_NOT_SENT_TOOLTIP : null;
}
